/**
 * Retrieves saved column order from localStorage
 * @param tableId - Unique identifier for the table
 * @returns Array of field names in saved order, or undefined if not found
 */
export const getColumnOrderFromLocalStorage = (
  tableId?: string
): string[] | undefined => {
  if (!tableId) return undefined;

  const columnOrderFromStorage = localStorage.getItem(`${tableId}-columnOrder`);
  if (columnOrderFromStorage) {
    try {
      const parsed = JSON.parse(columnOrderFromStorage);
      if (validateStringArray(parsed)) {
        return parsed;
      }
    } catch (error) {
      console.error("Error parsing column order from localStorage:", error);
      localStorage.removeItem(`${tableId}-columnOrder`);
    }
  }
  return undefined;
};

function validateStringArray(maybeArray: unknown) {
  return (
    Array.isArray(maybeArray) &&
    maybeArray.every((item) => typeof item === "string")
  );
}

/**
 * Saves column order to localStorage
 * @param tableId - Unique identifier for the table
 * @param orderedFields - Array of field names in desired order
 */
export const saveColumnOrderToLocalStorage = (
  tableId?: string,
  orderedFields?: string[]
): void => {
  if (tableId && orderedFields && orderedFields.length > 0) {
    localStorage.setItem(
      `${tableId}-columnOrder`,
      JSON.stringify(orderedFields)
    );
  }
};
